<script setup lang="ts">
import { LoadingSize } from '@/config'
import { useI18n } from 'vue-i18n'

interface Props {
  extraClasses?: string
  size?: LoadingSize
}

const props = withDefaults(defineProps<Props>(), {
  extraClasses: '',
  size: 'lg',
})

const { t } = useI18n()
</script>

<template>
  <div class="text-center" :class="props.extraClasses ? props.extraClasses : 'mt-3'">
    <div class="spinner-border text-center" :class="{ 'spinner-border-sm': props.size === 'sm' }" role="status">
      <span class="visually-hidden">{{ t('Loading...') }}</span>
    </div>
  </div>
</template>
